import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );

// const container = document.getElementById('root') || document.getElementById('admin-root');

// console.log('🐞 mounting into:', container);

// if (!container) {
//   throw new Error('Could not find a mount node (tried #root and #admin-root)');
// }

const container = document.getElementById('root');

if (!container) {
  throw new Error('Could not find a mount node with ID "root"');
}

const root = createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);